.list-tile {
  display: flex;
  margin: 16px 0;
  gap: 16px;

  > main {
    flex: 1;
  }

  .trailing {
    text-align: right;
  }

  &.align\:center {
    align-items: center;
  }
}
